<script>
import baseMixin from '@/mixins/baseMixin'
import { isNonEmptyArray } from '@/helpers/array-helpers'

export default {
  name: 'ClientGroupOverviewSchoolsTable',
  mixins: [baseMixin],
  props: {
    schools: {
      type: Array,
      default: () => [],
    },
  },
  data: () => {
    return {
      headers: [],
      search: '',
    }
  },
  computed: {
    computedHeaders() {
      return this.headers.filter((x) => x.display)
    },
    hasSchools() {
      return isNonEmptyArray(this.schools)
    },
    compSchoolsWithFillRate() {
      return !this.hasSchools ? [] : this.schools
    },
  },
  created() {
    this.initHeaders()
  },
  methods: {
    initHeaders() {
      this.headers = [
        {
          text: this.$t('clientGroupOverview.table.nameHeader'),
          value: 'displayName',
          display: true,
          sortable: true,
        },
        {
          text: this.$t('clientGroupOverview.table.filledHeader'),
          value: 'filledBookings',
          display: true,
          sortable: true,
          align: 'center',
          width: '10%',
        },
        {
          text: this.$t('clientGroupOverview.table.openHeader'),
          value: 'openBookings',
          display: true,
          sortable: true,
          align: 'center',
          width: '10%',
        },
        {
          text: this.$t('clientGroupOverview.table.bookingsHeader'),
          value: 'totalBookings',
          display: true,
          sortable: true,
          align: 'center',
          width: '12%',
        },
        {
          text: this.$t('clientGroupOverview.table.fileRateHeader'),
          value: 'fillRatePercentage',
          display: true,
          sortable: true,
          align: 'center',
          width: '10%',
        },
        {
          text: '',
          value: 'clientId',
          display: true,
          sortable: false,
          align: 'end',
          width: '40px',
        },
      ]
    },
    selectClient(clientId) {
      this.$emit('selectClient', clientId)
    },
    calcFillRatePercentage(school) {
      if (school.fillRatePercentage < 0) return 'NA'
      return `${school.fillRatePercentage}%`
    },
    rowClicked(row) {
      this.$emit('rowClicked', row.locationId)
    },
    getRowClass() {
      return 'cursor-pointer'
    },
  },
}
</script>

<template>
  <v-data-table
    data-testid="client-group-locations-table"
    :height="isMediumOrHigher ? '30vh' : ''"
    :headers="computedHeaders"
    :items="compSchoolsWithFillRate"
    :items-per-page="7"
    :footer-props="{
      'items-per-page-options': [7, 14, 21, -1],
    }"
    :item-class="getRowClass"
    :search="search"
    :sort-by="['displayName']"
    :sort-desc="[false]"
    color="blue"
    :class="['rounded-xl custom-elevation pt-2']"
    @click:row="rowClicked"
  >
    <template v-slot:top>
      <v-text-field
        v-model="search"
        clearable
        dense
        hide-details
        style="width: fit-content"
        prepend-inner-icon="mdi-magnify"
        :label="$t('input.searchLabel')"
        class="mx-4 mb-2"
      ></v-text-field>
    </template>

    <template v-slot:[`item.displayName`]="{ item }">
      <p class="mb-0">
        {{ item.displayName }}
      </p>
      <span class="caption">
        {{ item.address.fullAddress }}
      </span>
    </template>

    <template v-slot:[`item.fillRatePercentage`]="{ item }">
      {{ calcFillRatePercentage(item) }}
    </template>

    <template v-slot:[`item.clientId`]="{ item }">
      <v-btn
        :data-testid="
          `client-group-locations-table-${item.locationId}-view-client-btn`
        "
        icon
        @click="selectClient(item.clientId)"
      >
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </template>
  </v-data-table>
</template>
